import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toaster } from "@/components/ui/toaster";
import { ActionCode } from "@/constants/action-codes";
import { PermissionCode } from "@/constants/permissions";
import { useBlockedActions } from "@/hooks/useBlockedActions";

export const useBlockedActionGuard = (
  permissionCode: PermissionCode,
  actionCode: ActionCode,
  fallbackRoute: string,
  isActive: boolean = true,
) => {
  const navigate = useNavigate();
  const { isActionBlocked, loadingBlockedActions } = useBlockedActions(
    permissionCode,
    isActive,
  );

  const blocked = isActive && !loadingBlockedActions && isActionBlocked(actionCode);

  useEffect(() => {
    if (!blocked) return;

    toaster.create({
      type: "error",
      title: "No tienes permiso para realizar esta acción.",
    });
    navigate(fallbackRoute);
  }, [blocked, navigate, fallbackRoute]);

  return { allowed: !blocked, loadingBlockedActions };
};
